module.exports = __webpack_public_path__ + "static/media/160a.adfd1868.svg";